import style from './LuckyTryAgain.css';
import InfoTriangle from '../../../assets/images/info-triangle.webp';
import useTranslation from '../../../localization/i18n.context';
import Title from '../../shared/Typography/Title';
import BodyText from '../../shared/Typography/BodyText';
import Button from '../../shared/Button/Button';

export default function LuckyTryAgain({ onButtonClick }) {
  const { t } = useTranslation();
  return (
    <div className={`${style.main}`}>
      <div className={style.content}>
        <div className={style['feedback-image']}>
          <img src={InfoTriangle} width={160} height={160} />
        </div>

        <div className={style['feedback-text-wrapper']}>
          <div className={style['feedback-title']}>
            <Title text={t('Ooops!')} className="text-center" />
          </div>

          <div className={style['feedback-subtitle']}>
            <BodyText
              text={t('Something went wrong')}
              className={`text-center ${style['feedback-subtitle-text']}`}
            />
          </div>
        </div>
      </div>
      <div className={style['lucky-fixed-cta']}>
        <Button onClick={onButtonClick}>{t('Try Again')}</Button>
      </div>
    </div>
  );
}
